import React, { useState,useEffect } from "react";
import { Link as RouterLink, useLocation, useNavigate, useParams } from "react-router-dom";
// material
import { MenuItem, InputLabel, Select, FormControl, FormGroup, FormControlLabel, Checkbox, Stack, Card, CardContent, TextField, Button, Container, Box } from "@mui/material";
import Page from "../../components/Page";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import HeaderBreadcrumbs from "../../components/HeaderBreadcrumbs";
import Grid from "@mui/material/Unstable_Grid2";
import { ResetSettingsListAction, SettingsListAction } from "src/redux/actions/SettingsAction";
import { useDispatch, useSelector } from 'react-redux';

export default function CreatePool() {
    const dispatch = useDispatch();
    const settingSelector = useSelector(state => state.settings.setting_list)
    const settingData = settingSelector && settingSelector?.data?.data;

    

    let { id, gametype } = useParams();
    const navigate = useNavigate();
    const location = useLocation()
    const [state, setState] = useState({
        totalwinamt: 0,
        maxteams: 0,
        joinfee:0,
        contest_id: null,
        countrytype: '+91',
        makeContestConfirmed: false,
        teamType: false,
        usable_bonus_percentage:settingData?.usable_bonus_percentage
    });

const [adminCommission,setAdminCommission]=useState(settingData?.admin_commission);

    //const [usable_bonus_percentage,setUsableBonusPerc]=useState(settingData?.usable_bonus_percentage);

     useEffect(()=>{
         let pfees=localStorage.getItem("security_auth");
         pfees=JSON.parse(pfees);
         pfees=pfees && pfees.setting.filter(x=>x.key=="platformfee")[0]["value"];
          setAdminCommission(settingData?.admin_commission);

          //setUsableBonusPerc(settingData?.usable_bonus_percentage)
         let sstate = state;
         sstate["usable_bonus_percentage"]=settingData?.usable_bonus_percentage;
        setState(sstate);
    },[settingData])

    useEffect(() => {
        dispatch(SettingsListAction())
        return () => dispatch(ResetSettingsListAction())
    }, [])

    const stateHandler = (key, value) => {
        state[key] = value;
        setState({ ...state });
    };

    const submitContestFormData = (e) => {
        e.preventDefault();
        if (
            state.totalwinamt == 0 ||
            state.maxteams == 0,
            state.joinfee==0
        ) {
            toast.error("All Filed Must be filled", { theme: "colored" });
        } else {
            let sendData = {
                joinfee:state.joinfee, //Math.round(state.totalwinamt / state.maxteams),
              totalwinamt: ((state.maxteams * state.joinfee) - (state.maxteams * state.joinfee * adminCommission / 100)).toFixed(0),

                maxteams: state.maxteams,
                contest_id: id,
                type: location.state.match_type,
                name: location.state.name,
                countrytype: state.countrytype,
                gtype: gametype,
                c: state.makeContestConfirmed,
                s: state.teamType === false ? 1 : 0,
                m: state.teamType === true ? 1 : 0,
                usable_bonus_percentage:state.usable_bonus_percentage
            };
            navigate(`/dashboard/pool/${gametype}/${id}/break-point`, { state: { details: sendData } }, { replace: true });
            setState({
                ...state,
                totalwinamt: 0,
                maxteams: 0,
                joinfee:0,
                makeContestConfirmed: false,
                teamType: false,
            });
        }
    };
    
    return (
        <Page title="Create Pool Contest">

            <Container maxWidth="lg">
                <Box sx={{ flexGrow: 1 }}>
                    <Grid container spacing={2}>
                        <Grid xs={10}>
                            <HeaderBreadcrumbs
                                heading="Create Pool Contest"
                                links={[
                                    { name: "Dashboard", href: "/dashboard/app" },
                                    { name: "Contest List", href: "/dashboard/cricket/contest_list" },
                                    { name: "Pools" },
                                ]}
                            />
                        </Grid>
                    </Grid>
                </Box>

                <Card>
                    <CardContent>
                        <Grid container spacing={2}>
                            <Grid lg={6} style={{ margin: "auto" }}>
                                <Stack container spacing={3} style={{ marginTop: 30, marginBottom: 30 }}>
                                    <Grid container spacing={2}>
                                        <Grid md={6}>
                                            <FormControl fullWidth>
                                                <InputLabel id="select-country">IN/UK</InputLabel>
                                                <Select
                                                    labelId="select-country"
                                                    value={state.countrytype}
                                                    label="IN/UK"
                                                    onChange={({ target }) => setState({ ...state, countrytype: target.value })}
                                                >
                                                    <MenuItem value={"+91"}>India</MenuItem>
                                                    <MenuItem value={"+1"}>Uk</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        
                                        <Grid md={6}>
                                            <TextField
                                                 onChange={({ target }) => stateHandler("joinfee", target.value)}
                                                id="outlined-basic"
                                                label="Join fee"
                                                variant="outlined"
                                                //disabled
                                                //value={Math.round(state.totalwinamt / state.maxteams)}
                                                inputProps={{ min: "0", max: "4" }}
                                                type="number"
                                                fullWidth
                                            />
                                        </Grid>
                                        <Grid md={6}>
                                            <TextField
                                                onChange={({ target }) => stateHandler("maxteams", target.value)}
                                                type="number"
                                                id="outlined-basic"
                                                label="Max teams"
                                                variant="outlined"
                                                defaultValue={state.maxteams}
                                                fullWidth
                                            />
                                        </Grid>
                                        
                                        <Grid md={6}>
                                         Admin Commission = {adminCommission}% = {(state.maxteams * state.joinfee * adminCommission / 100).toFixed(2)}
   
                                            
                                        </Grid>
                                        <Grid md={6}>
                                            <TextField
                                                onChange={({ target }) => stateHandler("totalwinamt", target.value)}
                                                type="number"
                                                id="outlined-basic"
                                                label="Winning amount"
                                                variant="outlined"
                                               value={((state.maxteams * state.joinfee) - (state.maxteams * state.joinfee * adminCommission / 100)).toFixed(0)}

                                                fullWidth
                                            />
                                        </Grid>

                                        <Grid md={6}>
                                            <TextField
                                                onChange={({ target }) => stateHandler("usable_bonus_percentage", target.value)}
                                                type="number"
                                                id="outlined-basic"
                                                label="Bonus (Percentage)"
                                                variant="outlined"
                                                value={state.usable_bonus_percentage}
                                                fullWidth
                                            />
                                        </Grid>

                                        

                                        {/* {createPoolBreakFileds()} */}

                                        {/* <Grid xs={12}>
                                            <div align="right">
                                                <Button
                                                    onClick={() => addFormFields()}
                                                    variant="contained"
                                                > Add prize </Button>
                                            </div>
                                        </Grid> */}

                                        <Grid xs={12}>
                                            <FormGroup>
                                                <FormControlLabel control={
                                                    <Checkbox name="makeContestConfirmed" onChange={({ target }) => stateHandler("makeContestConfirmed", target.checked)} />
                                                } label="Confirmed winning even if the contest remains unfilled." />
                                                <FormControlLabel control={
                                                    <Checkbox name="teamType" onChange={({ target }) => stateHandler("teamType", target.checked)} />
                                                } label="Join with multiple teams." />
                                            </FormGroup>
                                        </Grid>
                                    </Grid>

                                    <Button
                                        align={"center"}
                                        style={{ marginTop: 20, width: "100%" }}
                                        variant="contained"
                                        onClick={(e) => submitContestFormData(e)}
                                    >
                                        Continue
                                    </Button>
                                </Stack>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Container>
        </Page>
    );
}